import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { Link } from 'react-router-dom';
import Axios from 'axios';
import Slider from 'react-slick';
import './index.scss';
import { apiHost, sourceHost } from '../../utils/Shared/constant';

const DEFAULT_STORY_IMAGE = '/banner_img/morakot-en_household-demographics.png';
// 先向後端撈同四分類全部（perPage=0 = 全部）（交給前端排序），再挑前 6 篇
const RECOMMENDATION_MAX = 6;

const BackArrowIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
		<rect width="30" height="30" fill="white"/>
		<path d="M23.75 13.75H11.25L15.3625 9.63751C15.4797 9.52131 15.5727 9.38306 15.6361 9.23073C15.6996 9.07841 15.7322 8.91503 15.7322 8.75001C15.7322 8.585 15.6996 8.42162 15.6361 8.26929C15.5727 8.11697 15.4797 7.97872 15.3625 7.86251C15.1283 7.6297 14.8115 7.49902 14.4812 7.49902C14.151 7.49902 13.8342 7.6297 13.6 7.86251L8.2375 13.2375C7.76802 13.7042 7.50279 14.338 7.5 15C7.50608 15.6576 7.77106 16.2864 8.2375 16.75L13.6 22.125C13.7165 22.2407 13.8547 22.3324 14.0067 22.3947C14.1587 22.457 14.3214 22.4888 14.4857 22.4882C14.6499 22.4876 14.8124 22.4547 14.964 22.3913C15.1155 22.3279 15.253 22.2353 15.3688 22.1187C15.4845 22.0022 15.5761 21.864 15.6384 21.712C15.7007 21.5601 15.7325 21.3973 15.7319 21.2331C15.7314 21.0688 15.6984 20.9063 15.6351 20.7548C15.5717 20.6033 15.479 20.4657 15.3625 20.35L11.25 16.25H23.75C24.0815 16.25 24.3995 16.1183 24.6339 15.8839C24.8683 15.6495 25 15.3315 25 15C25 14.6685 24.8683 14.3505 24.6339 14.1161C24.3995 13.8817 24.0815 13.75 23.75 13.75Z" fill="#7CA9FE"/>
	</svg>
);

const MoreArrowIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
		<path d="M15.8492 1.00001C15.8492 0.44773 15.4015 1.52364e-05 14.8492 1.49835e-05L5.84917 1.57843e-05C5.29688 1.54471e-05 4.84917 0.447731 4.84917 1.00002C4.84917 1.5523 5.29688 2.00002 5.84917 2.00002L13.8492 2.00002L13.8492 10C13.8492 10.5523 14.2969 11 14.8492 11C15.4015 11 15.8492 10.5523 15.8492 10L15.8492 1.00001ZM0.707031 15.1422L1.41414 15.8493L15.5563 1.70712L14.8492 1.00002L14.1421 0.292909L-7.55191e-05 14.435L0.707031 15.1422Z" fill="currentColor"/>
	</svg>
);

function StorySliderPrevButton(props) {
	const { onClick, className } = props;
	const disabled = className && className.indexOf('slick-disabled') > -1;
	return (
		<button className={`slick-prev slick-arrow ${disabled ? 'slick-disabled' : ''}`} onClick={onClick} aria-label="上一張" disabled={disabled}>
			<i className="icon-arrow-left"></i>
		</button>
	);
}

function StorySliderNextButton(props) {
	const { onClick, className } = props;
	const disabled = className && className.indexOf('slick-disabled') > -1;
	return (
		<button className={`slick-next slick-arrow ${disabled ? 'slick-disabled' : ''}`} onClick={onClick} aria-label="下一張" disabled={disabled}>
			<i className="icon-arrow-right"></i>
		</button>
	);
}

class SviStoryDetail extends Component {
	constructor(params) {
		super(params);
		this.state = {
			article: null,           // 當前文章（含指標名稱：IndicatorName/IndicatorCategoryName/IndicatorSubcategoryName）
			recommendations: [],     // 推薦文章（同指標四分類，各筆也帶指標名稱）
		};
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		this.props.onLoadHeaderColor('BLUE');
		this.props.onLoadHeaderTheme('DARK');
		this.props.onLoadShowLanguage('HIDE');

		const breadcrumb = [
			{ name: '首頁', href: '/' },
			{ name: '社會脆弱度', href: '/evaluation/svi' },
			{ name: '主題館', href: '/evaluation/svi/categories' },
			{ name: '案例故事', href: '/evaluation/svi/stories' },
		];
		this.props.onLoadShowBreadcrumb('SHOW', breadcrumb);

		this.loadArticle();
	}

	componentDidUpdate(prevProps) {
		if (prevProps.match.params.id !== this.props.match.params.id) {
			window.scrollTo(0, 0);
			this.loadArticle();
		}
	}

	loadArticle = () => {
		const id = this.props.match.params.id;
		Axios.get(`${apiHost}/api/Content/Article?ID=${id}`)
			.then(res => {
				const article = res.data && res.data.Result ? res.data.Result : null;
				this.setState({ article, recommendations: [] });
				if (article && article.IndicatorCategoryId) {
					this.loadRecommendations(article);
				}
			})
			.catch(err => {
				console.error('Load article failed:', err);
			});
	}

	loadRecommendations = (article) => {
		const params = new URLSearchParams();
		params.append('categoryId', article.IndicatorCategoryId);
		params.append('currentPage', 1);
		params.append('perPage', 0); // 0 = 全部撈，交給前端排序篩選
		Axios.get(`${apiHost}/api/Content/AvailableCaseStoryListByCategory?${params.toString()}`)
			.then(res => {
				const list = (res.data && res.data.Result) || [];
				// 依與當前文章的指標相符程度排序（由窄到寬），同等級內保持原本（日期新→舊）
				//   rank 1: 指標完全相同（level=3 same indicator_id）
				//   rank 2: 同次分類（level=2，IndicatorSubcategoryId 相同）
				//   rank 3: 同四分類（level=1，IndicatorCategoryId 相同）
				//   rank 4: 其他（理論上不會出現，因為 API 已限定同四分類）
				const curIndId = article.IndicatorId;
				const curSubId = article.IndicatorSubcategoryId;
				const curCatId = article.IndicatorCategoryId;
				const matchRank = (s) => {
					if (curIndId != null && s.IndicatorId === curIndId) return 1;
					if (curSubId != null && s.IndicatorSubcategoryId === curSubId) return 2;
					if (curCatId != null && s.IndicatorCategoryId === curCatId) return 3;
					return 4;
				};
				const sorted = list
					.filter(a => a.ID !== article.ID)
					.map((a, idx) => ({ a, idx, rank: matchRank(a) }))
					.sort((x, y) => x.rank - y.rank || x.idx - y.idx)
					.slice(0, RECOMMENDATION_MAX)
					.map(x => x.a);
				this.setState({ recommendations: sorted });
			})
			.catch(err => {
				console.error('Load recommendations failed:', err);
				this.setState({ recommendations: [] });
			});
	}

	formatDate = (dateStr) => {
		const d = new Date(dateStr);
		const y = d.getFullYear();
		const m = String(d.getMonth() + 1).padStart(2, '0');
		const day = String(d.getDate()).padStart(2, '0');
		return `${y}/${m}/${day}`;
	}

	getDateParts = (dateStr) => {
		const d = new Date(dateStr);
		const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
		return {
			year: d.getFullYear(),
			month: months[d.getMonth()],
			day: String(d.getDate()).padStart(2, '0'),
		};
	}

	// 從文章/清單項目上直接取得顯示用 tag（依 IndicatorLevel 決定要幾顆）
	// level=1 (四分類) → 1 顆 ：[四分類]
	// level=2 (次分類) → 2 顆 ：[四分類][次分類]
	// level=3 (指標)   → 3 顆 ：[四分類][次分類][指標]
	buildTagsFrom = (item) => {
		if (!item) return [];
		const level = item.IndicatorLevel || 0;
		const tags = [];
		if (item.IndicatorCategoryName) {
			tags.push({ text: item.IndicatorCategoryName, variant: 'outline' });
		}
		if (level >= 2 && item.IndicatorSubcategoryName) {
			tags.push({ text: item.IndicatorSubcategoryName, variant: 'outline' });
		}
		if (level >= 3 && item.IndicatorName) {
			tags.push({ text: item.IndicatorName, variant: 'outline' });
		}
		if (tags.length > 0) tags[tags.length - 1].variant = 'filled';
		return tags;
	}

	renderRecommendationCard = (story) => {
		const tags = this.buildTagsFrom(story);
		const imgPath = story.ImageUrl ? `${sourceHost}/${story.ImageUrl}` : DEFAULT_STORY_IMAGE;
		return (
			<div className="svi-story-slider__slide" key={story.ID}>
				<Link className="story-item" to={`/evaluation/svi/story/${story.ID}`} aria-label="閱讀案例故事文章">
					<article className="story-card">
						<div className="story-card__image">
							<img src={imgPath} alt="案例故事文章示意圖" className="story-card__img" />
						</div>
						<div className="story-card__tags">
							{tags.map((tag, i) => (
								<span key={i} className={`story-card__tag story-card__tag--${tag.variant}`}>{tag.text}</span>
							))}
						</div>
						<h3 className="story-card__title">{story.Title}</h3>
						<p className="story-card__summary">{story.Summary}</p>
						<time className="story-card__date" dateTime={story.Published}>{story.Published}</time>
					</article>
				</Link>
			</div>
		);
	}

	render() {
		const { article, recommendations } = this.state;

		const dateParts = article ? this.getDateParts(article.Published || article.Date || '') : { year: '', month: '', day: '' };
		const tags = article ? this.buildTagsFrom(article) : [];
		const coverImage = article && article.ImageUrl ? `${sourceHost}/${article.ImageUrl}` : DEFAULT_STORY_IMAGE;
		// 返回案例故事連結：優先用上一頁傳來的 from（SviCaseStoryList Link 帶的），否則 fallback 到 /evaluation/svi/stories
		const backPath = (this.props.location && this.props.location.state && this.props.location.state.from) || '/evaluation/svi/stories';

		const sliderSettings = {
			dots: true,
			infinite: false,
			speed: 500,
			slidesToShow: 3,
			slidesToScroll: 1,
			prevArrow: <StorySliderPrevButton />,
			nextArrow: <StorySliderNextButton />,
			responsive: [
				{
					breakpoint: 1024,
					settings: { slidesToShow: 2, slidesToScroll: 1 }
				},
				{
					breakpoint: 780,
					settings: { slidesToShow: 1, slidesToScroll: 1, centerMode: true, centerPadding: '20px' }
				},
				{
					breakpoint: 600,
					settings: { slidesToShow: 1, slidesToScroll: 1, centerMode: true, centerPadding: '20px' }
				},
			],
		};

		return (
			<React.Fragment>
				{article && (
					<Helmet>
						<title>{article.Title} - 減災動資料</title>
					</Helmet>
				)}
				<div className="page-story-detail">
					<main>
						<div className="article-page">
							<div className="container">
								<Link className="article-back-link" to={backPath} aria-label="返回案例故事">
									<BackArrowIcon />
									<span className="article-back-link-text">返回案例故事</span>
								</Link>
							</div>

							{article && (
								<React.Fragment>
									<section className="article-heading">
										<div className="container">
											<div className="row">
												<div className="col-2 col-lg-1">
													<div className="datemonth -blue">
														<span className="year">{dateParts.year}</span>
														<span className="month type-text -en -lg">{dateParts.month}</span>
														<span className="date type-heading -en -h1">{dateParts.day}</span>
													</div>
												</div>
												<div className="col-10 col-lg-9 offset-lg-1">
													<div className="tag-group">
														{tags.map((tag, i) => (
															<span key={i} className={`tag-pill -${tag.variant}`}>{tag.text}</span>
														))}
													</div>
													<h1 className="story-title type-heading -ch -h4">{article.Title}</h1>
												</div>
											</div>
										</div>
									</section>

									<section className="article-content">
										<div className="container">
											<div className="row">
												<div className="col-10 col-lg-9 offset-2">
													{coverImage && (
														<div className="image">
															<img src={coverImage} alt="" />
														</div>
													)}

													{/* className 原本是 "mt-5 article-text"，改用 "content type-text -ch" 對齊 ArticlePage 內文樣式 */}
													<article
														className="mt-5 content type-text -ch"
														dangerouslySetInnerHTML={{ __html: article.Content || '' }}
													/>
												</div>
											</div>
										</div>
									</section>
								</React.Fragment>
							)}

							{!article && (
								<React.Fragment>
									<section className="article-heading">
										<div className="container">
											<div className="row">
												<div className="col-2 col-lg-1">
													<div className="datemonth -blue">
														<span className="month type-text -en -lg "></span>
														<span className="date type-heading -en -h1 "></span>
													</div>
												</div>
												<div className="col-10 col-lg-9 offset-lg-1">
													<div className="tag-group">
														<span className="tag-pill -filled -loading-block">loading</span>
													</div>
													<h1 className="story-title type-heading -ch -h4 -loading-block">Lorem ipsum dolor sit amet consectetur</h1>
												</div>
											</div>
										</div>
									</section>

									<section className="article-content">
										<div className="container">
											<div className="row">
												<div className="col-10 col-lg-9 offset-2">
													<div className="-loading-block empty-content" style={{ height: '300px' }}>loading</div>
													<article className="content mt-5">
														<div className="-loading-block empty-content">loading</div>
														<div className="-loading-block empty-content">loading</div>
														<div className="-loading-block empty-content">loading</div>
														<div className="-loading-block empty-content">loading</div>
														<div className="-loading-block empty-content">loading</div>
														<div className="-loading-block empty-content">loading</div>
														<div className="-loading-block empty-content">loading</div>
														<div className="-loading-block empty-content">loading</div>
													</article>
												</div>
											</div>
										</div>
									</section>
								</React.Fragment>
							)}
						</div>

						{article && (
							<section className="svi-story-section">
								<div className="container">
									<h2 className="story-section-title">案例故事推薦</h2>
									{recommendations.length > 0 ? (
										<div className="svi-story-slider">
											<Slider {...sliderSettings}>
												{recommendations.map(s => this.renderRecommendationCard(s))}
											</Slider>
										</div>
									) : (
										<p className="svi-story-empty text-center" style={{ padding: '40px 0', color: '#888' }}>
											尚無相關推薦文章
										</p>
									)}
									<Link className="more-btn d-table mx-auto" to="/evaluation/svi/stories">
										看更多文章
										<MoreArrowIcon />
									</Link>
								</div>
							</section>
						)}
					</main>
				</div>
			</React.Fragment>
		);
	}
}

export default SviStoryDetail;
